import { useCombobox } from 'downshift';

// this adds select on blur functionality to downshift
// https://github.com/downshift-js/downshift/issues/1040
const stateReducer = (state, { props, type, changes }) => {
  switch (type) {
    case useCombobox.stateChangeTypes.InputBlur:
      // force select if there are suggestions and they have any input
      if (props.items.length && state.inputValue) {
        const selectedIndex = state.highlightedIndex >= 0 ? state.highlightedIndex : 0;
        return {
          highlightedIndex: -1,
          isOpen: false,
          inputValue: props.itemToString(props.items[selectedIndex]),
          selectedItem: props.items[selectedIndex],
        };
      }
      return changes;
    default:
      return changes;
  }
};

export default stateReducer;
